import React, { ComponentProps, lazy } from 'react';

import { Box } from 'components/Box';
import { ClientOnlySuspense } from 'components/ClientOnlySuspense';

import LogoIdealistSVG from 'logo-idealist.svg';

import { BaseLogo } from './BaseLogo';

const LazyLogoStaffSVG = lazy(() => import('logo-staff.svg'));

export function IdealistLogo({
  showStaffMarker,
  ...props
}: Omit<ComponentProps<typeof BaseLogo>, 'children'> & {
  showStaffMarker?: boolean;
}) {
  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <BaseLogo {...props}>
      <Box height="100%" position="relative" display="inline-block">
        <canvas width="347.913" height="167.883" />
        <Box position="absolute" top={0} left={0} width="100%" height="100%">
          <LogoIdealistSVG />
        </Box>
      </Box>
      {showStaffMarker && (
        <>
          <canvas width="45.976" height="167.883" />
          <Box height="100%" position="relative" display="inline-block">
            <canvas width="184.444" height="167.883" />
            <Box
              position="absolute"
              top={0}
              left={0}
              width="100%"
              height="100%"
            >
              <ClientOnlySuspense>
                <LazyLogoStaffSVG />
              </ClientOnlySuspense>
            </Box>
          </Box>
        </>
      )}
    </BaseLogo>
  );
}
